import { css } from '@emotion/css';

export const generateImageStyles = {
  addButton: css`
    width: 100%;
    height: 100%;
    margin: 0 auto;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: white;
    border: 1px solid #e8e8e8;
    cursor: pointer;
    aspect-ratio: 1 / 1;

    &:hover {
      background-color: #f0f0f0;
    }
  `,

  imageThumbnail: css`
    width: 100%;
    height: 100%;
    margin: 0 auto;
    border-radius: 12px;
    overflow: hidden;
    position: relative;
    cursor: pointer;
    transition: all 0.3s;
    padding: 0;
    aspect-ratio: 1 / 1;

    &:hover {
      box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);
      transform: translateY(-2px);
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      aspect-ratio: 1 / 1;
    }
  `,

  selectedImageGrid: css`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
    width: 100%;
    height: calc(100dvh - 185px);
  `,

  gridImageContainer: css`
    position: relative;
    border-radius: 8px;
    overflow: hidden;
    cursor: pointer;
    transition: all 0.3s;
    aspect-ratio: 1 / 1;

    &:hover {
      box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);
      transform: translateY(-2px);
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  `,

  removeButton: css`
    position: absolute;
    top: 4px;
    right: 4px;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background-color: rgba(0, 0, 0, 0.6);
    color: white;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-size: 12px;
    z-index: 2;

    &:hover {
      background-color: rgba(0, 0, 0, 0.8);
    }
  `,

  modalImageCard: css`
    position: relative;
    cursor: pointer;
    transition: all 0.3s;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    }
  `,

  selectedOverlay: css`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(24, 144, 255, 0.3);
    border: 2px solid #1890ff;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;
  `,

  selectedCheckmark: css`
    width: 32px;
    height: 32px;
    background-color: #1890ff;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 16px;
    font-weight: bold;
  `,

  inputStyle: css`
    flex: 1;
    margin-right: 15px;
    border-radius: 8px;
    margin-bottom: 15px;
  `,

  generateButton: css`
    background-color: black;
    border-radius: 8px;
    height: 45px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 20px;
    width: 100%;
  `,
};
